import React, { useEffect, useState } from 'react';
import { Button, Panel } from 'govuk-react-jsx';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
  setDisplayGoBackLink,
} from '../../../features/app/appSlice';
import { getClaimsData } from '../../../features/customer/customerJourneySlice';
import useTitle from '../../../hooks/useTitle';
import useGaEndEvent from '../../../hooks/useGaEndEvent';
import { getWordingTemplates } from '../../../firebase';

const ResubmitConfirm = () => {
  const dispatch = useDispatch();
  // NEW: State for dynamic wording

  const [dynamicWording, setDynamicWording] = useState({
    message: null,
    is_dynamic: false,
  });
  const { grantType, id } = useParams();

  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const claimsValue = useSelector(getClaimsData);
  const claimData = claimsValue.filter((c) => c.document_id === id)[0];
  useEffect(() => {
    const fetchWordingTemplates = async () => {
      try {
        setIsLoading(true);
        dispatch(setDisplayGoBackLink(false));

        // ✅ FIXED: Added await and language parameter
        const response = await getWordingTemplates({
          grantType: claimsValue[0].grant_type,
        });

        if (response.data?.success && response.data?.data) {
          console.log('✅ Dynamic wording fetched:', response.data.data);

          setDynamicWording({
            message: response.data.data,
            is_dynamic: response.data.data.is_dynamic,
          });
        }
      } catch (error) {
        console.error('Error fetching wording templates:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWordingTemplates(); // ✅ FIXED: Call the async function
  }, [grantType, currentLanguage, dispatch]);
  useTitle(
    'Installer.Resubmit.ConfirmResubmit.s11',
    'Claim resubmitted - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  useGaEndEvent('ResubmitClaim', 'resubmit_claim_end');

  const headingTxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s1',
    'We will now review your resubmitted claim'
  );
  const subHeadingTxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s2',
    'Your reference number: '
  );
  const secondHeadingTxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s3',
    'What happens next'
  );
  const firstPtxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s4',
    'The Office for Zero Emission Vehicles (OZEV) will now assess your claim.'
  );
  const thirdPtxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s6',
    'You can check the progress of your claim on your manage your claims page.'
  );
  const btnTxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s9',
    'Manage your claims'
  );
  const linkTxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s7',
    'What did you think of this service?'
  );
  const fourthPtxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s8',
    '(takes 30 seconds)'
  );
  const thirdHeadingTxt = copyProvider.getCopy(
    'Installer.Resubmit.ConfirmResubmit.s10',
    'Help to make this service better'
  );

  const handleBtnCLick = () => {
    history.push('/installer/claim-grant/installer-dashboard');
  };
  const getMessage = () => {
    // Before activation → Show hardcoded

    if (!dynamicWording.is_dynamic) {
      return copyProvider.getCopy(
        'Installer.Resubmit.ConfirmResubmit.s5',
        'We will aim to tell you, within 20 working days, whether your claim is successful, or to ask you for more information.'
      );
    }

    const message =
      currentLanguage === 'en'
        ? dynamicWording.message.resubmit20_message_en
        : dynamicWording.message.resubmit20_message_cy;

    if (message === '') {
      return '';
    }

    // If null or undefined → Show hardcoded
    if (message === null || message === undefined) {
      return copyProvider.getCopy(
        'Installer.Resubmit.ConfirmResubmit.s5',
        'We will aim to tell you, within 20 working days, whether your claim is successful, or to ask you for more information.'
      );
    }

    // If has value → Show dynamic text
    return message;
  };
  if (isLoading) {
    return (
      <div className="govuk-grid-row">
        <p className="govuk-body">Loading...</p>
      </div>
    );
  }
  return (
    <>
      <Panel titleChildren={headingTxt}>
        {subHeadingTxt}
        <br /> <strong>{claimData.customerReferenceNumber}</strong>
      </Panel>
      <h2 className="govuk-heading-m">{secondHeadingTxt}</h2>
      <p className="govuk-body">{firstPtxt}</p>
      <p className="govuk-body">{getMessage()}</p>
      <p className="govuk-body">{thirdPtxt}</p>
      <Button onClick={handleBtnCLick}>{btnTxt}</Button>
      <h3 className="govuk-heading-s govuk-!-margin-top-2">
        {thirdHeadingTxt}
      </h3>
      <p className="govuk-body">
        <Link
          href="https://www.smartsurvey.co.uk/s/EV-grants/"
          target="_blank"
          rel="noopener noreferrer"
          className="govuk-link"
        >
          {linkTxt}
        </Link>
        {fourthPtxt}
      </p>
    </>
  );
};

export default ResubmitConfirm;
